import React from "react";
import "./optimizertable.css";
import DataNotFound from "../../DataNotFound/DataNotFound";
import ShimmerTable from "../../Tables/ShimmerTable";
import { useState } from "react";
import { useRef } from "react";
import { useEffect } from "react";
import CustomPagination from "../../CustomPagination/CustomPagination";
import { Box, FormControl, MenuItem, Select, Typography } from "@mui/material";

const PAGE_SIZE_OPTIONS = [50, 100, 200, 300, 500];

const OptimizerTable = ({
  tableHeaders,
  resultSet,
  tableclassName,
  className,
  customClasses,
  renderSummaryRow,
  renderTableHeader,
  isSummaryRowRequired,
  renderTableRow,
  totalSummary,
  renderComparisonFirstRow,
  isComparisonView,
  tableLoading,
  childRowsLoading,
  isExpandable,
  getData,
  recordLimit,
  recieveLoadedData,
  resetOffset,
  noDataFound,
  mainTableClass,
  rowsCount,
  handleEditableCellClick,
  updateEditableCell,
  handleEditableValueChange,
  setParentPageLimit = () => {},
}) => {
  const [loading, setLoading] = useState(false);
  const mainRef = useRef(null);
  const effectivePageLimit = recordLimit || 50;


  const allRows = resultSet?.map((result, index) => {
    return renderTableRow(
      result,
      index,
      childRowsLoading,
      isExpandable
    );
  })
  const currentRowCount = rowsCount || 0;
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationOffset, setPaginationOffset] = useState(0);
  const currentRows = allRows ?? []
  const count = rowsCount;
  const { isNext, isPrev, totalPages } = getPaginationInfo(
    count ?? 0,
    effectivePageLimit,
    currentPage
  );
  // const {totalPages:totalPagesMain} = getPaginationInfo(overAllAdsCount?.total_count ?? 0,frontEndPaginationLimit,currentPage)
  function getPaginationInfo(totalNumber, limit, pageNumber) {
    // Calculate total number of pages
    const totalPages = Math.ceil(totalNumber / limit);
    // Determine if there's a next page
    const isNext = pageNumber < totalPages;
    // Determine if there's a previous page
    const isPrev = pageNumber > 1;
    return {
        isNext: isNext,
        isPrev: isPrev,
        totalPages: totalPages
    };
}

  useEffect(() => {
    setCurrentPage(1);
  },[resetOffset])

  function getFreezeColumnClassName (keyName) {
    switch (keyName) {
      case "targeting":
       return "targeting-columns"
      default:
        break;
    }
  }

   const handlePageChange = async (pageNumber) => {
    const currentOffset = (pageNumber - 1) * effectivePageLimit;
    const dataForMoreData = {
          page: pageNumber,
          offset: currentOffset,
          limit: effectivePageLimit,
        };
        setLoading(true);
        const mainData = await getData(dataForMoreData);
        recieveLoadedData(mainData);
        setCurrentPage(pageNumber);
        setPaginationOffset(currentOffset);
        setLoading(false);
    };
  
    useEffect(() => {
      handlePageChange(1)
    }, [effectivePageLimit]);
  


  
  return (
    <div className="optimizer-main-table">
      <div
        className={
          className
            ? `main-tableRb-body  position-relative d-flex flex-column` +
              className
            : "main-tableRb-body position-relative d-flex flex-column"
        }
      >
        <div
          className={
            "tableRb text-center" + (tableclassName ? tableclassName : "")
          }
        >
          <div
            className={
              "main-campaignlist-table-body main-targeting-table-body-container listinng-table comparison-view-wrapper" + (mainTableClass ? mainTableClass : "")
            }
            ref={mainRef}
            // onScroll={handleScroll}
          >
            {
              <>
                {tableLoading || loading ? (
                  <ShimmerTable
                    rows={20}
                    tableHeaders={tableHeaders}
                    hideHeaders={false}
                  />
                ) : noDataFound ? (
                  <DataNotFound />
                ) : (
                  <>
                    <table className={`optimizer-table targeting-columns`}>
                      <thead className="fixed-table">
                        <tr className="main-table-row-fixed">
                          {tableHeaders?.map((data) => {
                            return renderTableHeader(data, isComparisonView);
                          })}
                        </tr>
                      </thead>
                      {resultSet?.length ? (
                        <tbody className="another-tbody">
                          {isSummaryRowRequired
                            ? renderSummaryRow(totalSummary)
                            : null}
                          {isComparisonView ? renderComparisonFirstRow() : null}
                          {/* {currentRows?.map((result, index) => {
                            return renderTableRow(
                              result,
                              index,
                              childRowsLoading,
                              isExpandable
                            );
                          })} */}
                          {currentRows}
                        </tbody>
                      ) : (
                        <DataNotFound />
                      )}
                    </table>
                    {/* {loading && (
                      <div className="lazy-loading-container d-flex p-2 justify-content-center align-items-center w-100">
                        <LazyLoadSpinner
                          text={`Loading ${recordLimit} More Items...`}
                        />
                      </div>
                    )} */}
                  </>
                )}
              </>
            }
          </div>
        </div>
      </div>
      {!tableLoading &&
        !loading &&
        (resultSet?.length > 0 || currentPage > 1) && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 1,
              py: 2,
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                color: "#4f5366",
              }}
            >
              <Typography variant="body2" sx={{ fontSize: "12px" }}>
                Page Size
              </Typography>
              <FormControl size="small" sx={{ minWidth: 80 }}>
                <Select
                  value={effectivePageLimit}
                  onChange={(e) => setParentPageLimit(Number(e.target.value))}
                  disabled={loading}
                  sx={{
                    height: 36,
                    fontSize: "12px",
                    color: "#333333",
                  }}
                  MenuProps={{ disableScrollLock: true }}
                >
                  {PAGE_SIZE_OPTIONS.map((option) => (
                    <MenuItem
                      key={option}
                      value={option}
                      sx={{ fontSize: "12px" }}
                    >
                      {option}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>

            <CustomPagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
              lazyLoading={loading}
              totalItems={count ?? 0}
              itemsPerPage={effectivePageLimit}
            />
          </Box>
        )}
      </div>
  );
};

export default OptimizerTable;
